"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = FileUpload;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const Button_1 = require("../Button");
function getBase64(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result));
        reader.readAsDataURL(file);
    });
}
const showBigSizeNotification = (intl, fileSize) => {
    antd_1.notification.error({
        message: intl.formatMessage({
            id: 'profile.resume.notification',
            defaultMessage: 'Upozornenie',
        }),
        description: `${intl.formatMessage({
            id: 'profile.resume.max_img_size',
            defaultMessage: 'Maximálna veľkosť obrázku je',
        })} ${fileSize}MB`,
        placement: 'bottomRight',
    });
};
function FileUpload({ name, accept, maxFileSize, wholeFileList, setFileList, ...props }) {
    const intl = (0, react_intl_1.useIntl)();
    const checkFileSize = react_1.default.useCallback((e, fileSizeMb) => {
        const isFileSizeInBounds = e.size / 1024 / 1024 < fileSizeMb;
        if (!isFileSizeInBounds) {
            showBigSizeNotification(intl, fileSizeMb);
            setFileList([]);
        }
        return isFileSizeInBounds;
    }, [intl, setFileList]);
    return ((0, jsx_runtime_1.jsx)(antd_1.Upload, { ...props, beforeUpload: e => checkFileSize(e, maxFileSize), action: file => getBase64(file), onChange: ({ file, fileList }) => {
            if (file.status) {
                props.onChange(fileList);
                setFileList(fileList);
            }
        }, accept: accept, name: name, fileList: wholeFileList, maxCount: props.maxCount || 1, children: (0, jsx_runtime_1.jsx)(Button_1.Button, { size: props.size || 'middle', type: "default", icon: (0, jsx_runtime_1.jsx)(icons_1.UploadOutlined, { className: "m-r-s" }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.upload", defaultMessage: "Upload" }) }) }));
}
